import { Slider, Tooltip } from '@nextui-org/react';
import React, { MouseEvent } from 'react';
import { Chapter } from '../App';
import { formatTime } from '../TimeFormat';

interface ProgressSliderProps {
    played: number;
    playedSeconds: number;
    duration: number;
    onSeek: (value: number | number[]) => void;
    onSeekMouseUp: (value: number | number[]) => void;
    onMouseSeekDown: () => void;
    chapters: Chapter[];
}


const ProgressSlider = (props: ProgressSliderProps) => {
    const sliderRef = React.useRef<HTMLInputElement | null>(null);

    const handleSeekPress = (e: MouseEvent<HTMLDivElement>) => {
        if (!sliderRef.current) return;
        let rect = sliderRef.current.getBoundingClientRect();
        const clickPercentage = ((e.clientX - rect.left) / rect.width) * 100;
        props.onSeek((clickPercentage / 100) * props.duration);
    };

    return (
        <div className='relative w-full mx-4'>
            <div className='absolute top-1/2 h-12 w-full z-10 -translate-y-1/2'
                onClick={handleSeekPress}
            >
                {props.chapters.map((chapter, index) => {
                    let chapterDuration = chapter.end - chapter.start;
                    let chapterPlayed = props.playedSeconds > chapter.start
                        ? (props.playedSeconds < chapter.end ? props.playedSeconds - chapter.start : chapterDuration)
                        : 0;
                    let chapterPlayedPercentage = chapterPlayed / chapterDuration * 100;
                    chapterPlayedPercentage = chapterPlayedPercentage >= 100 ? 99 : chapterPlayedPercentage;
                    return (
                        <Tooltip
                            key={index}
                            size='sm'
                            content={chapter.title}
                        >
                            <div
                                key={index}
                                className={`absolute top-1/2 h-2 rounded-ful -translate-y-1/2 hover:h-3`}
                                style={{
                                    left: `${((chapter.start) / props.duration) * 100}%`,
                                    width: `${((chapter.end - chapter.start) / props.duration) * 100}%`,
                                    background: `linear-gradient(to right, rgba(147, 83, 211, 1) 0%, rgba(147, 83, 211, 1) ${chapterPlayedPercentage}%, rgba(255, 255, 255, 1) ${chapterPlayedPercentage}%, rgba(255, 255, 255, 1) 99%, rgba(255, 255, 255, 0) 99%, rgba(255, 255, 255, 0) 100%)`,
                                }}
                                onClick={handleSeekPress}>
                            </div>
                        </Tooltip>);
                })}
            </div>
            <Slider
                id={'progress-slider'}
                ref={sliderRef}
                size='sm'
                minValue={0}
                maxValue={isNaN(props.duration) ? 0 : props.duration}
                className='z-0'
                color='secondary'
                aria-label={'progress slider'}
                value={isNaN(props.playedSeconds) ? 0 : props.playedSeconds}
                onChange={props.onSeek}
                onChangeEnd={props.onSeekMouseUp}
                onMouseDown={props.onMouseSeekDown}
                showTooltip
                tooltipProps={{
                    content: `${formatTime(props.playedSeconds)}`,
                }}
                classNames={{
                    /*track: 'h-1 hover:h-3  transition-all duration-300 ease-in-out',*/
                    track: 'h-0',
                    filler: 'h-0',
                    thumb: 'z-30',
                }}
            />
        </div>
    );
};

export default ProgressSlider;